// // export default api;

// import axios from 'axios';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_REPORTS_API_URL,
//   withCredentials: false,
// });

// // attach token if present
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem('finz_token');
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// export default api;

// src/api/axios.ts
import axios from "axios";

const baseURL =
  process.env.REACT_APP_REPORTS_API_URL ??
  (process.env.NODE_ENV === "production"
    ? "https://stgapi.finzcard.com"
    : "http://localhost:8000");

console.log("✅ Axios Base URL:", baseURL);

const api = axios.create({
  baseURL,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("finz_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
